export function getDominantStudioState({
  eventId,
  eventState = "NO_CLASS",
  hasAttention = false,
  receptionistOnly = false,
  scheduleCount = 0,
  readinessReady = false,
  studioLifecycle = "UNKNOWN",
} = {}) {
  if (eventState === "RUNNING") return receptionistOnly ? "CLASS IN PROGRESS" : "CLASS RUNNING";
  if (eventState === "STARTED") return "CLASS STARTING";
  if (eventState === "PAUSED") return "CLASS PAUSED";
  if (eventState === "FINISHED") return "CLASS COMPLETE";
  if (hasAttention) return "ATTENTION REQUIRED";
  if (!eventId || eventState === "NO_CLASS") return "NO CURRENT CLASS";
  if (receptionistOnly) {
    if (eventState === "SCHEDULED") return "CLASS SCHEDULED";
    return scheduleCount ? "UPCOMING CLASS" : "READY TO START";
  }
  if (readinessReady) return "READY TO START";
  return studioLifecycle !== "UNKNOWN" ? studioLifecycle : "NOT READY";
}

export function formatAttendanceSummary({ checkedInCount = 0, rosterCount = 0, rosterProvided = true } = {}) {
  const numerator = Number.isFinite(checkedInCount) ? Number(checkedInCount) : 0;
  const denominator = Number.isFinite(rosterCount) ? Number(rosterCount) : 0;

  if (!rosterProvided || denominator === 0) {
    return { numerator: 0, denominator: null, caption: "No roster supplied." };
  }

  const caption = `${numerator} / ${denominator} checked in`;
  return {
    numerator,
    denominator,
    caption,
  };
}

export function formatScheduleAttendance(attendance) {
  if (Array.isArray(attendance)) {
    return `${attendance.length} checked in`;
  }
  return "Attendance unavailable";
}
